import React, { Component } from 'react';
import { withRouter } from "react-router";
import { ajax, unparam, agoraClient, setTokenById } from "./utils/common";
import { Modal } from "antd";
import VideoModel from "components/videoModel";
//视频面试状态
import VideoStatus from "components/videoStatus";
// 国际化
import i18nZh_cn from "./utils/zh_cn";
import i18nEn_us from "./utils/en_us";

class App extends Component {
    state = {
        hasLogin: false,
        showModal: false,
        videoStatus: 0
    }

    componentDidMount(){
        //获取页面参数
        const queryString = unparam(window.location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        this.setState({
            i18n
        })
        //重定向到首页
        let userAgent = window.navigator.userAgent;
        const { history, location } = this.props;
        const excludePath = ["/index", "/result", "/result/mobile", "/bind", "/create", "/reportFlow", "/oivib", "/analysis", "/aiReport", "/aiIndex", "/privacy"];
        if(excludePath.indexOf(location.pathname) < 0){
            history.replace({
                pathname: "/index",
                search: "?accountId="+ queryString.accountId + "&lang=" + lang
            });
        } else {
            // aiIndex页面pc处理去新版aipc面试
            if(userAgent.indexOf("Mobile") < 0 && location.pathname.includes('/aiIndex')){
                window.location.href = `/webai/AISubpackages/privacy/index${location.search}`;
                return;
            }
            // ai报告重定向
            if(location.pathname.includes('/aiReport')){
                window.location.href = `/webai/aiReport${location.search}`
                return;
            }
        }
        if(location.pathname === "/bind" ||
            location.pathname === "/create" ||
            location.pathname === "/reportFlow" ||
            location.pathname === "/oivib" ||
            location.pathname === "/analysis" ||
            location.pathname === "/aiIndex"){
            this.setState({
                hasLogin: true
            })
            return false;
        }
        //登出
        ajax({
            url: "/sys/loginout"
        }).then(res => {
            console.log("logout success");
            //登录
            this.login(queryString);
        }).catch(err => {
            //登录
            this.login(queryString);
        })
        //unload执行退出登录
        window.onbeforeunload = null;
        window.onbeforeunload = function(event) {
            ajax({
                url: "/sys/loginout"
            }).then(res => {
                console.log("logout success");
            })
            //离开频道
            // agoraClient.leave(() => {
            //     console.log("Leavel channel successfully");
            // }, err => {
            //     console.log("Leave channel failed");
            // });
        }
    }

    hideModal = () => {
        //关闭页面
        history.back();
        window.close();
    }

    login = (params) => {
        const { i18n } = this.state;
        ajax({
            url: "/sys/loginon",
            data: {
                accountId: params.accountId,
                timeSign: params.timeSign
            }
        }).then(sessionId => {
            console.log("登录成功, accountId: ", params.accountId, sessionId);
            // localStorage.sessionId = sessionId.data;
            // sessionStorage.sessionId = sessionId.data;
            setTokenById(params.accountId, sessionId.data);
            this.setState({
                hasLogin: true
            })
        }).catch(err => {
            if(err.status == 503){
                this.setState({
                    showModal: true,
                    videoStatus: 4
                })
            }else{
                Modal.info({
                    title: i18n.showModal.title,
                    content: err.message,
                    okText: i18n.device.btnText,
                })
            }
        })
    }

    render() {
        const { hasLogin, showModal, videoStatus, i18n } = this.state;

        // 国际化
        if(!i18n) return null;

        return (
            <React.Fragment>
                {hasLogin ? this.props.children : null}
                {showModal ? <div className="video-app-wrap video-background-wrap">
	                <VideoModel title={i18n.showModal.titlePC} visible={showModal}>
	                    <VideoStatus status={videoStatus} hideModal={this.hideModal} />
	                </VideoModel>
                </div> : null}
            </React.Fragment>
        )
    }
}

const WrapRouter = withRouter(App);

export default WrapRouter;
